import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

/**
 * Form level error messages, one paragraph per message.
 *
 * @param {object} props Props.
 * @param {string|string[]|List} [props.errors] Error message(s), nothing is rendered when empty.
 * @param {string} [props.className] Paragraph class names.
 */
const FormErrors = ({ errors, className = 'text-danger mt8 mb0' }) => {
  const messages = List.isList(errors) ? errors.toArray() : [].concat(errors ?? []);

  return messages.filter(Boolean).map((message, index) => (
    <p key={index} className={className}>
      {message}
    </p>
  ));
};

FormErrors.propTypes = {
  className: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.instanceOf(List)]),
};

export default memo(FormErrors);
